import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useParams } from "react-router-dom";
import { BookingLayout, BOOK_API, SlotPicker, fmtSlot } from "../components/site/Booking";

export default function VisiteManage() {
  const { token } = useParams();
  const [b, setB] = useState(null);
  const [err, setErr] = useState("");
  const [move, setMove] = useState(false);
  const [slot, setSlot] = useState(null);
  const [busy, setBusy] = useState(false);
  const [info, setInfo] = useState("");
  const load = () => axios.get(`${BOOK_API}/${token}`).then((r) => setB(r.data)).catch(() => setErr("Réservation introuvable."));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [token]);
  const act = async (fn, ok) => {
    setBusy(true);
    setErr("");
    try { await fn(); setInfo(ok); setMove(false); await load(); } catch (e) { setErr(e.response?.data?.detail || "Action impossible, appelez-nous."); } finally { setBusy(false); }
  };
  return (
    <BookingLayout title="Votre visite" eyebrow="Rangement à domicile" testId="visit-manage-page">
      <div className="rounded-2xl bg-white p-6" data-testid="visit-manage">
        {!b && !err && <Loader2 className="h-6 w-6 animate-spin" />}
        {err && <p className="mb-3 rounded-lg bg-red-50 px-4 py-3 text-sm font-semibold text-red-700" data-testid="visit-error">{err}</p>}
        {info && <p className="mb-3 rounded-lg bg-green-50 px-4 py-3 text-sm font-semibold text-green-800" data-testid="visit-info">{info}</p>}
        {b && (
          <>
            <p className="text-lg text-cs-navy" data-testid="visit-when"><b>{b.status === "annulee" ? "Visite annulée" : "Visite confirmée"}</b> – {b.when}</p>
            <p className="mt-1 text-cs-ink/70">{b.address}</p>
            {b.editable ? (
              <div className="mt-5 flex flex-wrap gap-3">
                <button type="button" className="btn-accent px-5 py-3" onClick={() => setMove(!move)} data-testid="visit-move-toggle">Changer de créneau</button>
                <button type="button" disabled={busy} className="rounded-full border border-red-300 px-5 py-3 font-bold text-red-700" data-testid="visit-cancel"
                  onClick={() => window.confirm("Annuler la visite ?") && act(() => axios.post(`${BOOK_API}/${token}/cancel`), "Votre visite est annulée. Un email de confirmation vous a été envoyé.")}>Annuler la visite</button>
              </div>
            ) : b.status === "confirmee" && <p className="mt-4 text-sm text-cs-ink/70" data-testid="visit-locked">Moins de 12 h avant la visite : pour toute modification, appelez-nous ou écrivez à info@stopcheni.ch.</p>}
            {move && (
              <div className="mt-6 space-y-4">
                <SlotPicker value={slot} onPick={setSlot} />
                {slot && <button type="button" disabled={busy} className="btn-accent w-full py-3.5" data-testid="visit-move-confirm" onClick={() => act(() => axios.post(`${BOOK_API}/${token}/reschedule`, slot), `Visite déplacée au ${fmtSlot(slot)}.`)}>Confirmer le {fmtSlot(slot)}</button>}
              </div>
            )}
          </>
        )}
      </div>
    </BookingLayout>
  );
}
